
export function calculateDiscountPrice(profileSalary, feeRate, feeDiscountRate=0, availableDiscountAmount) {
  if (!profileSalary || !feeRate) return {};

  const salary = parseInt(profileSalary);
  const fee = parseInt(salary * feeRate/100);
  const vat = parseInt((salary + fee) / 10);
  const total = parseInt(salary + fee + vat);

  // fee discount
  const feeDcAmount = parseInt(salary * feeDiscountRate/100);
  let tempFee = fee - feeDcAmount;
  const dcAmount = Math.min(availableDiscountAmount, salary + tempFee);

  let finFee = tempFee;
  let finSalary = salary;
  if (dcAmount > 0) {
    if (dcAmount >= tempFee) {
      finFee = 0;
      finSalary = Math.max(salary + tempFee - dcAmount, 0);
    } else {
      finFee = tempFee - dcAmount;
    }
  }
  const finVat = parseInt((finSalary + finFee) / 10);
  const finTotal = parseInt(finSalary + finFee + finVat);

  return {
    fee: fee,
    vat: vat,
    total: total,
    finSalary: finSalary,
    finFee: finFee,
    finVat: finVat,
    finTotal: finTotal,
    dcAmount: dcAmount,
    feeDcAmount: feeDcAmount,
  }
}
